import { TestimonialCarousel } from '../../../components/quiz';
import { TrustpilotBadge } from '../../../components/shared';
import type { Testimonial } from '../../../types';

interface TrustStepProps {
  userType: 'BUSINESS' | 'INDIVIDUAL';
}

const TESTIMONIALS: Testimonial[] = [
  {
    quote: 'Sequence gave me the keys to my wallet back and the clarity I needed to drive it where I want to go.',
    author: '',
    title: 'Business Owner',
    stars: 5,
  },
  {
    quote: 'Took all my worry about when and how much money get sent out each paycheck no missed payment',
    author: '',
    title: 'Working Professional',
    stars: 5,
  },
  {
    quote: 'Living paycheck to paycheck, able to now set money back with purpose',
    author: '',
    title: 'Personal Finance',
    stars: 5,
  },
  {
    quote: 'It gave me a clearer picture of my financial situation.',
    author: '',
    title: 'Entrepreneur',
    stars: 5,
  },
  {
    quote: 'Worry and fear to hope and security',
    author: '',
    title: 'Family Finance',
    stars: 5,
  },
];

export default function TrustStep({ userType }: TrustStepProps) {
  const headline = userType === 'BUSINESS'
    ? 'A Blueprint Built for Business Growth'
    : 'A Blueprint Built Around Your Life';

  const subtitle = userType === 'BUSINESS'
    ? "We've helped thousands of businesses get ahead of their finances, now let's match the perfect flow for your business"
    : "We've helped thousands organize their finances - now we'll match the perfect plan for you";

  return (
    <div className="trust-step">
      <div className="trust-step__header">
        <h1 className="trust-step__headline">{headline}</h1>
        <p className="trust-step__subtitle">{subtitle}</p>
      </div>

      <div className="trust-step__stats">
        <div className="trust-step__stat-card">
          <div className="trust-step__stat-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <span className="trust-step__stat-value">66%</span>
          <span className="trust-step__stat-label">Feel more optimistic about their financial future</span>
        </div>

        <div className="trust-step__stat-card">
          <div className="trust-step__stat-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
          </div>
          <span className="trust-step__stat-value">76%</span>
          <span className="trust-step__stat-label">Report lower money-related stress</span>
        </div>
      </div>
      <p className="trust-step__stats-source">Based on a survey of Sequence users, 2024</p>

      <TrustpilotBadge />

      <TestimonialCarousel testimonials={TESTIMONIALS} autoRotateMs={4000} showArrows />
    </div>
  );
}
